module.exports = __webpack_public_path__ + "img/icon_save.8582bc40.svg";